import { ReactNode } from 'react'

import { useI18n } from '../../i18n/index.js'
import { useFirstRenderContext } from '../ssr/FirstRenderProvider.js'
import { getLocalizedDateFormat } from '../utils/date.js'

export interface TimeProps {
  dateTime: string
  className?: string
  children?: ReactNode
}

export const Time = ({ dateTime, className, children }: TimeProps) => {
  /**
   * Both `dateTime` and `title` defer to a server-stable format on the
   * first render. `getLocalizedDateFormat` uses `navigator.language` on
   * subsequent renders, which would otherwise produce a different string
   * on the client than the dayjs fallback used during SSR — a hydration
   * mismatch surfaced once Posts/Feed started rendering in SSR HTML.
   */
  const { isFirstRender } = useFirstRenderContext()
  const { localeCode } = useI18n()

  const { dateTime: dateTimeFormatted } = getLocalizedDateFormat(
    dateTime,
    localeCode,
    undefined,
    isFirstRender,
  )

  return (
    <time
      dateTime={dateTimeFormatted}
      title={isFirstRender ? undefined : dateTimeFormatted}
      className={className}
    >
      {children}
    </time>
  )
}
